export const ResourceLinksSkeleton = () => {
  return (
    <div className="space-y-3 animate-pulse">
      {[1, 2, 3, 4].map((item) => (
        <div
          key={item}
          className="rounded-lg border border-gray-200 p-4"
        >
          <div className="mb-3 flex items-start justify-between gap-3">
            {/* Title */}
            <div className="h-4 w-3/4 rounded bg-gray-200" />

            {/* Icon */}
            <div className="h-4 w-4 rounded bg-gray-200" />
          </div>

          {/* Category */}
          <div className="mb-2 h-3 w-1/2 rounded bg-gray-200" />

          {/* Type */}
          <div className="h-3 w-20 rounded bg-gray-200" />
        </div>
      ))}
    </div>
  );
};